var render = function render(_c,_vm){return (_vm.value)?_c('span',{staticClass:"bxs-logo"},[_c('i',{staticClass:"iconfont icon-logo_bao"}),_c('i',{staticClass:"iconfont icon-logo_xian"}),_c('i',{staticClass:"iconfont icon-logo_shi"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }